import { RpcObservableRequestContext } from '../rpc-observable-request';
import { RpcObservableResultContext } from '../rpc-observable-result';

/**
 * RPC alive request name and version.
 */
export class RpcObservableAliveKey {
    public static command = 'AliveObservable';
    public static version = '0.1.0';
}

/**
 * Rpc observable alive data.
 */
export interface RpcObservableAliveRequest extends RpcObservableRequestContext {
    /**
     * The timestamp. Date.now() / the number of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
     */
    timestamp: number;

    /**
     * The flag indicating not to close the window from this tool indefinitely.
     */
    forever?: boolean;
}

export type RpcObservableAliveResult = RpcObservableResultContext;

export interface RpcObservableAliveError extends RpcObservableResultContext {
    error: Error;
}
